import { Component, HostBinding, OnInit, OnDestroy, HostListener, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Article } from './article.model';
import { ArticleService } from './article.service';
import { NavigationService } from '../shared/navigation/navigation.service';
import { Page } from '../shared/navigation/pages.model';
import { Subscription } from 'rxjs';
import { environment } from '../../environments/environment';
import { utils } from '../shared/helpers/utils';

@Component({
  selector: 'app-article',
  templateUrl: 'article.component.html',
  styleUrls: ['article.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class ArticleComponent implements OnInit, OnDestroy {
 public cdn = environment.cdn;
 public path_details = '/';
 public pageTitle: string;
 public pageContent: string;
 public articles: Article[];
 public children: Page[] = [];
 public currentUrl = '';
 public count = 0;
 public pageSize = 12;
 public page = 0;
 public query: any = {page: 1, pagesize: 12};
 public sub: Subscription = null;
 public sub1: Subscription = null;
 public sub2: Subscription = null;
 public categories: Page[] = [];
 public selected: number;
 public links = ['First', 'Second', 'Third'];
 public catsVisible = 'expanded';

 @HostListener('window:resize', ['$event'])
    onResize(event) {
      if (event.target.innerWidth < 599) {
        this.catsVisible = 'collapsed';
      } else {
        this.catsVisible = 'expanded';
      }
  }

 constructor(private router: Router, private route: ActivatedRoute, private navigationService: NavigationService,
             private articleService: ArticleService, private cdr: ChangeDetectorRef) {
    // console.log(this.router.config);
    this.path_details = this.router.config.find(r => r.data?.module === 'ArticleDetailsModule')?.data.path || '/';  
    // console.log(this.path_details);
    this.sub2 = this.navigationService.navigation.subscribe(this.pageChanged);

    if (window.innerWidth < 599) {
      this.catsVisible = 'collapsed';
    } else {
      this.catsVisible = 'expanded';
    }
 }

 ngOnInit() {

  this.currentUrl = this.router.url;
  this.selected = this.route.snapshot.data['id'];
  if (this.selected) {
    this.query['category'] = this.selected;
  }
  this.pageTitle = this.route.snapshot.data.name;
  this.pageContent = this.route.snapshot.data.content;

  this.sub = this.route.queryParamMap.subscribe(params => {
    this.getArticles();
  });


 }

 pageChanged = (menu: any) => {
  // let c = JSON.parse(JSON.stringify(menu.footer));
  // console.log(menu);
  // this.children = utils.filterData(c, '', '', '', this.route.snapshot.data.id, this.route.snapshot.data.parent);
}

 trackArticleBy(index, article) {
   return index;
 }

 onPage(event: any) {
     this.query['page'] = event.pageIndex + 1;
     this.query['pagesize'] = event.pageSize;
     this.router.navigate([this.currentUrl], { queryParams: this.query });
 }

 getArticles() {
    this.sub1 = this.articleService.items(this.query).subscribe(articles => {
      this.articles = articles.items || [];
      this.page = 0;
      this.count = articles.pages.totalItemCount || 0;
      this.cdr.markForCheck();
    }, error => {
      // console.log(error);
    });
 }

 ngOnDestroy() {
   if (this.sub) {
     this.sub.unsubscribe();
   }
   if (this.sub1) {
     this.sub1.unsubscribe();
   }
   if (this.sub2) {
     this.sub2.unsubscribe();
   }
 }

}
